import React from 'react';

const EmailVerificationPage = (props) => {
  return <div className="p-4"> Email Verified Successfully!</div>;
};

export default EmailVerificationPage;
